module.exports = __webpack_public_path__ + "img/headerBackgroundImg.bba2e3a3.png";